import axios from 'axios';

// apply base url for axios
const API_URL = '';

const axiosApi = axios.create({
  baseURL: API_URL,
});

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export async function get(url, config = {}) {
  // pass new generated access token here
  const user = JSON.parse(localStorage.getItem('authUser'));
  const zebra = JSON.parse(localStorage.getItem('selectedPrinter'));

  if (user) {
    axiosApi.defaults.headers.common['x-access-token'] = user.token;
    axiosApi.defaults.headers.common['x-selected-printer'] = zebra;
  }

  return axiosApi.get(url, { ...config }).then((response) => response.data);
}

export async function post(url, data, config = {}) {
  const user = JSON.parse(localStorage.getItem('authUser'));
  const zebra = JSON.parse(localStorage.getItem('selectedPrinter'));

  if (user) {
    axiosApi.defaults.headers.common['x-access-token'] = user.token;
    axiosApi.defaults.headers.common['x-selected-printer'] = zebra;
  }

  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  const user = JSON.parse(localStorage.getItem('authUser'));
  const zebra = JSON.parse(localStorage.getItem('selectedPrinter'));

  if (user) {
    axiosApi.defaults.headers.common['x-access-token'] = user.token;
    axiosApi.defaults.headers.common['x-selected-printer'] = zebra;
  }

  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  const user = JSON.parse(localStorage.getItem('authUser'));
  const zebra = JSON.parse(localStorage.getItem('selectedPrinter'));

  if (user) {
    axiosApi.defaults.headers.common['x-access-token'] = user.token;
    axiosApi.defaults.headers.common['x-selected-printer'] = zebra;
  }

  return axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
